import * as CODE_GEN from '../constant/code-gen'
import * as common from '@/utils/common'
import { DEFAULT_DATETIME_FORMAT, DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from '@/constant/system/time'

/**
 * 代码生成工具
 *
 * @author Jay Qing
 * @since 2021/05/20
 */

/**
 * 推断属性对应的组件属性
 *
 * @param prop 属性
 * @return {{}} 组件属性
 */
export function deduceComponentAttrs(prop: any) {
  const ui = prop.uiComponent
  if (ui.name === CODE_GEN.UI_COMPONENTS.INPUT.name) {
    return deduceInputAttrs(prop)
  } else if (ui.name === CODE_GEN.UI_COMPONENTS.SELECT_TIME.name ||
    ui.name === CODE_GEN.UI_COMPONENTS.SELECT_DATE.name ||
    ui.name === CODE_GEN.UI_COMPONENTS.SELECT_DATETIME.name) {
    return deduceDatetimeSelectAttrs(prop)
  } else {
    return {}
  }
}

/**
 * 推断输入框组件的属性
 *
 * @param prop 属性
 * @return {{}} 组件属性
 */
function deduceInputAttrs(prop: any) {
  const attrs: any = {}
  const ui = prop.uiComponent
  if (ui.name === CODE_GEN.UI_COMPONENTS.INPUT.name) {
    const length = common.substringBetween(prop.columnType, '(', ')')
    if (length && !isNaN(parseInt(length))) {
      attrs.maxlength = parseInt(length)
    }
    attrs['clearable'] = 'true'
  } else if (ui.name === CODE_GEN.UI_COMPONENTS.INPUT_DECIMAL) {
    attrs['controls-position'] = 'right'
    attrs['precision'] = '2'
    attrs['step'] = '0.1'
  } else if (ui.name === CODE_GEN.UI_COMPONENTS.INPUT_INTEGER) {
    attrs['controls-position'] = 'right'
  }
  return attrs
}

/**
 * 推断日期时间选择框的属性
 *
 * @param prop 属性
 * @return {{}} 组件属性
 */
function deduceDatetimeSelectAttrs(prop: any) {
  const ui = prop.uiComponent
  const attrs: any = {}
  let valueFormat = DEFAULT_DATE_FORMAT
  if (ui.name === CODE_GEN.UI_COMPONENTS.SELECT_DATE.name) {
    attrs.type = 'date'
    valueFormat = DEFAULT_DATE_FORMAT
  } else if (ui.name === CODE_GEN.UI_COMPONENTS.SELECT_DATETIME.name) {
    attrs.type = 'datetime'
    valueFormat = DEFAULT_DATETIME_FORMAT
  } else if (ui.name === CODE_GEN.UI_COMPONENTS.SELECT_TIME.name) {
    valueFormat = DEFAULT_TIME_FORMAT
  }
  attrs['valueFormat'] = valueFormat
  return attrs
}

